// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__fJVqe","header":"MessagesList_header__KPmJX","chat":"MessagesList_chat__wj5dd"};